module.exports = __webpack_public_path__ + "img/contact_head.2d850711.png";